require('./userAddress.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');

const UserAddress = props => {
    const { immProfileFields, modifier, ellipsisClass } = props;
    let content;

    if (immProfileFields.get('isFetching')) {
        content = <LoadingSection />
    } else {
        let address = PersonalDataHelper.getFormattedAddress(immProfileFields);
        const userAddressClassName = classNames (
            'user-address',
            {
                [`user-address--${modifier}`]: modifier
            }
        );
        const userAddressConfirmationStepClassName = classNames (
            { 'user-address__paragraph--ellipsis': ellipsisClass }
        );

        content = (
            <section className={userAddressClassName}>
                <p className={userAddressConfirmationStepClassName}>{address}</p>
            </section>
        )
    }

    return content;
};

UserAddress.propTypes = {
    immProfileFields: PropTypes.object.isRequired,
    modifier: PropTypes.oneOf(['new-card-details','confirmation-step', 'inline']),
    ellipsisClass: PropTypes.bool
};

UserAddress.defaultProps = {
    ellipsisClass: false
}

module.exports = UserAddress;
